import { render, staticRenderFns } from "./SsFile.vue?vue&type=template&id=369286e2&scoped=true&"
import script from "./SsFile.vue?vue&type=script&lang=js&"
export * from "./SsFile.vue?vue&type=script&lang=js&"
import style0 from "./SsFile.vue?vue&type=style&index=0&id=369286e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369286e2",
  null
  
)

export default component.exports